// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.P_fq1B {
  height: 100%;
}

.uwpTUV {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  padding: var(--spacing-3) 0 0;
  margin: 0 auto;
  flex: 1;
}

.Vzw5el {
  font-size: var(--type-title-lg-font-size);
  font-weight: var(--type-title-lg-font-weight);
  color: var(--text-neutral-dark);
  margin: 0;
  font-family: var(--font-family-base);
}

.YItdvI {
  flex: 1;
}

.OF_Ese {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  height: 100%;
  gap: var(--spacing-3);
  padding: var(--spacing-4);
  box-sizing: border-box;
  width: 100%;
}

.Z7ozJ3 {
  background: var(--loading-background);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
}

.nAKRXk {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.zbYHqp {
  position: fixed;
  right: 24px;
  top: 64px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/NewRechargePage.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,OAAO;AACT;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".rechargerPageContainer {\n  height: 100%;\n}\n\n.initialLoadingPage {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 100%;\n  padding: var(--spacing-3) 0 0;\n  margin: 0 auto;\n  flex: 1;\n}\n\n.pageTitle {\n  font-size: var(--type-title-lg-font-size);\n  font-weight: var(--type-title-lg-font-weight);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  font-family: var(--font-family-base);\n}\n\n.initialLoadingContent {\n  flex: 1;\n}\n\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  gap: var(--spacing-3);\n  padding: var(--spacing-4);\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.loadingIcon {\n  background: var(--loading-background);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n}\n\n.loadingText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.alertMessage {\n  position: fixed;\n  right: 24px;\n  top: 64px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rechargerPageContainer": `P_fq1B`,
	"initialLoadingPage": `uwpTUV`,
	"pageTitle": `Vzw5el`,
	"initialLoadingContent": `YItdvI`,
	"loadingContainer": `OF_Ese`,
	"loadingIcon": `Z7ozJ3`,
	"loadingText": `nAKRXk`,
	"alertMessage": `zbYHqp`
};
module.exports = ___CSS_LOADER_EXPORT___;
